var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySize50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3333",
    "data-name": "Group 3333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.402,
    height: 68.391,
    viewBox: "0 0 73.402 68.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_size_50_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2636",
    "data-name": "Rectangle 2636",
    width: 73.402,
    height: 68.391,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    clipPath: "url(#company_size_50_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M174.834,227.423V275H129.583V227.423H127.6V275.99a.992.992,0,0,0,.992.992h47.235a.992.992,0,0,0,.992-.992V227.423Z",
    transform: "translate(-117.052 -208.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M325.727,655.443H308.181a.992.992,0,0,0-.992.992v2.128a.992.992,0,1,0,1.984,0v-1.136h15.562v10.211H309.173V657.524a.992.992,0,1,0-1.984,0V668.63a.992.992,0,0,0,.992.992h17.546a.992.992,0,0,0,.992-.992V656.435a.992.992,0,0,0-.992-.992",
    transform: "translate(-281.797 -601.264)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M414.312,655.443a.992.992,0,0,0-.992.992V668.63a.992.992,0,0,0,1.984,0V656.435a.992.992,0,0,0-.992-.992",
    transform: "translate(-379.155 -601.264)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M129.584,62.568V47.083h45.251V62.568h1.984V46.091a.992.992,0,0,0-.992-.992H128.592a.992.992,0,0,0-.992.992V62.568Z",
    transform: "translate(-117.053 -41.371)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M186.418,110.5h-5.4a.992.992,0,0,0-.992.992v6.085a.992.992,0,0,0,.992.992h5.4a.992.992,0,0,0,.992-.992v-6.085a.992.992,0,0,0-.992-.992m-.992,6.085h-3.419v-4.1h3.419Z",
    transform: "translate(-165.142 -101.362)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M320.159,110.5h-5.4a.992.992,0,0,0-.992.992v6.085a.992.992,0,0,0,.992.992h5.4a.992.992,0,0,0,.992-.992v-6.085a.992.992,0,0,0-.992-.992m-.992,6.085h-3.419v-4.1h3.419Z",
    transform: "translate(-287.828 -101.362)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M453.9,110.5h-5.4a.992.992,0,0,0-.992.992v6.085a.992.992,0,0,0,.992.992h5.4a.992.992,0,0,0,.992-.992v-6.085a.992.992,0,0,0-.992-.992m-.992,6.085h-3.419v-4.1h3.419Z",
    transform: "translate(-410.513 -101.362)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M587.639,110.5h-5.4a.992.992,0,0,0-.992.992v6.085a.992.992,0,0,0,.992.992h5.4a.992.992,0,0,0,.992-.992v-6.085a.992.992,0,0,0-.992-.992m-.992,6.085h-3.419v-4.1h3.419Z",
    transform: "translate(-533.198 -101.362)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M149.03,0H96.488A.992.992,0,0,0,95.5.992V4.707a.992.992,0,0,0,.992.992H149.03a.992.992,0,0,0,.992-.992V.992A.992.992,0,0,0,149.03,0m-.992,3.715H97.48V1.984h50.558Z",
    transform: "translate(-87.602)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M294.342,470.476a.992.992,0,0,0-.992.992v7.607a.992.992,0,0,0,1.984,0v-7.607a.992.992,0,0,0-.992-.992",
    transform: "translate(-269.102 -431.586)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M527.75,470.476a.992.992,0,0,0-.992.992v7.607a.992.992,0,0,0,1.984,0v-7.607a.992.992,0,0,0-.992-.992",
    transform: "translate(-483.216 -431.586)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M407.89,470.476a.992.992,0,0,0-.992.992v7.607a.992.992,0,1,0,1.984,0v-7.607a.992.992,0,0,0-.992-.992",
    transform: "translate(-373.264 -431.586)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M219.583,468.337H181.015a.992.992,0,0,0-.992.992v8.138a.992.992,0,0,0,.992.992h38.568a.992.992,0,0,0,.992-.992v-8.138a.992.992,0,0,0-.992-.992m-.992,8.138H182.007v-6.154h36.584Z",
    transform: "translate(-165.142 -429.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M333.9,468.337h-.215a.992.992,0,1,0,0,1.984h.215a.992.992,0,1,0,0-1.984",
    transform: "translate(-305.19 -429.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M294.342,274.638a.992.992,0,0,0-.992.992v7.607a.992.992,0,1,0,1.984,0V275.63a.992.992,0,0,0-.992-.992",
    transform: "translate(-269.102 -251.936)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M527.75,274.638a.992.992,0,0,0-.992.992v7.607a.992.992,0,1,0,1.984,0V275.63a.992.992,0,0,0-.992-.992",
    transform: "translate(-483.216 -251.936)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M407.89,274.638a.992.992,0,0,0-.992.992v7.607a.992.992,0,1,0,1.984,0V275.63a.992.992,0,0,0-.992-.992",
    transform: "translate(-373.264 -251.936)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M219.583,272.5H181.015a.992.992,0,0,0-.992.992v8.138a.992.992,0,0,0,.992.992h38.568a.992.992,0,0,0,.992-.992v-8.138a.992.992,0,0,0-.992-.992m-.992,8.138H182.007v-6.154h36.584Z",
    transform: "translate(-165.142 -249.974)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M72.41,803.381H.992a.992.992,0,0,0,0,1.984H72.41a.992.992,0,0,0,0-1.984",
    transform: "translate(0 -736.973)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySize50);
export default __webpack_public_path__ + "static/media/company_size_50.c6245115.svg";
export { ForwardRef as ReactComponent };